export default __webpack_public_path__ + "static/media/cust2.c2fe43eb.webp";